import { createContext } from 'react';

export const UserCatContext = createContext<any>(null);
